import loadingGif from 'assets/gif/FreeSensLoader05.gif';

const Loading = ({ size = '100px', mt = '0px' }) => {
  return (
    <img
      src={loadingGif}
      style={{
        height: size,
        width: size,
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, 50%)',
        marginTop: mt
      }}
    />
  );
};
export default Loading;
